import React, { useEffect } from 'react';
import { Layout, Breadcrumb, Empty, Button } from 'antd';
import * as S from './Organizations.styled';
import { IsAcceptedSelector, IsManagerSelector, IsOwnerSelector } from 'features/User/UserSlice';
import Meta from 'components/Meta';
import { useSelector } from 'react-redux';
import OrganizationsList from 'features/OrganizationsList';
import { useAppDispatch } from 'hooks/useStore';
import { openCreateOrganizationModal } from 'features/CreateOrganizationModal/CreateOrganizationModalSlice';
import { fetchOrganizations } from 'features/OrganizationsList/OrganizationsListSlice';

const { Content } = Layout;

const Organizations = (): JSX.Element => {
	const dispatch = useAppDispatch();

	// Подтвержденность пользователя
	const isAccepted = useSelector(IsAcceptedSelector);
	const isManager = useSelector(IsManagerSelector);
	const isOwner = useSelector(IsOwnerSelector);

	useEffect(() => {
		console.log(isOwner);
		if (isOwner || (isAccepted && isManager)) dispatch(fetchOrganizations());
	}, [dispatch, isAccepted, isManager, isOwner]);

	const onOpenCreateOrganizationModal = () => dispatch(openCreateOrganizationModal());

	return (
		<Content
			style={{
				padding: '0px 20px 20px 20px',
				display: 'flex',
				flexDirection: 'column',
			}}>
			<Meta pageName="requests" />
			<Breadcrumb
				items={[{ title: 'realty platform' }, { title: 'organizations' }]}
				style={{ margin: '16px 0' }}
			/>
			<S.WorkSpace>
				{isOwner || (isAccepted && isManager) ? (
					<>
						<S.Header>
							<Button
								type="primary"
								size="large"
								block
								disabled={!isOwner}
								onClick={onOpenCreateOrganizationModal}>
								Add organization
							</Button>
						</S.Header>
						<OrganizationsList />
					</>
				) : (
					<S.Empty>
						<Empty
							image={Empty.PRESENTED_IMAGE_SIMPLE}
							description="You do not have the necessary rights to view this section"
						/>
					</S.Empty>
				)}
			</S.WorkSpace>
		</Content>
	);
};

export default Organizations;
